import { create } from 'zustand';

type ChaosMode = 'disabled' | 'low' | 'medium' | 'high';

interface ChaosStore {
  mode: ChaosMode;
  setChaosMode: (newMode: ChaosMode) => void;
}

const storedMode = typeof window !== 'undefined' ? (localStorage.getItem('chaosMode') as ChaosMode) : null;

export const useChaosStore = create<ChaosStore>((set) => ({
  mode: storedMode ?? 'disabled',
  setChaosMode: (newMode) => {
    localStorage.setItem('chaosMode', newMode);
    set({ mode: newMode });
  },
}));